import { IconBan } from "@tabler/icons-react";

/**
 * Stands in for a product thumbnail on an empty area the labeler reviewed and
 * marked "No match". Before this, such a row showed only the green checkmark —
 * which says the area was reviewed but not what the decision was — while a
 * matched row showed the product picture.
 *
 * Same 32px tile as ProductImageThumbnail so the two line up down the list —
 * the point of DTOPS-259 was that a no-match row should carry a picture the
 * way a matched row does. That only fits because the sidebar is 240px wide;
 * at the old 220px the source badge was squeezed to "AU…". The glyph is the
 * same IconBan the footer's "No match" button uses.
 */
export const NoMatchThumbnail = () => {
  return (
    <div
      className="size-8 shrink-0 border rounded flex items-center justify-center text-gray-500"
      title="No match — reviewed, no matching product"
      data-testid="no-match-thumbnail"
    >
      <IconBan size={20} />
    </div>
  );
};
